module.exports = __webpack_public_path__ + "img/hr-tree-04-g-trunk.a31e9c03.png";